export default __webpack_public_path__ + "static/media/recruit_section_image_3@3x.7a0d7178.webp";